
















































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {譲渡譲受医療機関登録依頼型} from '@/type/transfermedical/register';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';

@Component({
  components: {
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    AlertDialog,
  },
})

export default class RegisterTransferMedical extends Vue {

  譲渡譲受医療機関登録依頼: 譲渡譲受医療機関登録依頼型 = this.初期譲渡譲受医療機関登録依頼();
  アラートメッセージ: string[] = [];

  @Prop({default: false})
  private modal!: boolean;

  public created() {
    this.init();
  }

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean) {
    if (nowModal) {
      this.openDialog('譲渡譲受医療機関マスタ新規画面');
    }
  }

  @Emit('close-form')
  private closeForm() {
    this.clear();
    this.closeDialog('譲渡譲受医療機関マスタ新規画面');
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private registerHandler() {
    progress(this.register);
  }

  private async register(): Promise<void> {
    await api.譲渡譲受医療機関を登録する(this.譲渡譲受医療機関登録依頼)
      .then(
        () => {
          this.closeDialog('確定ダイアログ');
          this.closeForm();
        },
        (error: any) => {
          this.closeDialog('確定ダイアログ');
          if (error.data.errors) {
            this.アラートメッセージ = [].concat(error.data.errors);
          }
          if (error.data.message && !error.data.errors) {
            this.アラートメッセージ = this.アラートメッセージ.concat(error.data.message);
          }
          this.openDialog('譲渡譲受入力アラートダイアログ');
        },
      );
  }

  private clear() {
    this.init();
    this.closeDialog('クリアダイアログ');
  }

  private init() {
    this.譲渡譲受医療機関登録依頼 = this.初期譲渡譲受医療機関登録依頼();
  }

  private 初期譲渡譲受医療機関登録依頼(): 譲渡譲受医療機関登録依頼型 {
    return {
      医療機関コード: '',
      医療機関名: '',
      医療機関名カナ: '',
      住所1: '',
      住所2: '',
      電話番号: '',
      FAX番号: '',
      表示順: 0,
    };
  }
}
